module.exports = __webpack_public_path__ + "static/media/check-in.8f692cd8.svg";